/* eslint-disable @typescript-eslint/no-unused-vars */
/*
 *   Copyright (c) 2021
 *   All rights reserved.
 */
import { IRootState } from 'src/redux/interface';
import {
    apiGetProfileInfo,
    apiUpdateAccount,
    apiGetProfileByAddress,
} from 'src/modules/Accounts/redux/Account.service';
import BigNumber from 'bignumber.js';
import { actionLogout as logOutAuth } from 'src/modules/Auth/Auth.actions';
import { actionUpdateAccessToken } from 'src/redux/walletAccount/WalletAccount.action';
import { ENVS } from '../../../configs/Configs.env';

export const ACTION_TYPES = {
    UPDATE_ACCOUNT: 'UPDATE_ACCOUNT',
    LOGOUT: 'LOGOUT',
    UPDATE_WALLETS: 'UPDATE_WALLETS',
};

export const actionGetProfileInfo =
    (token: string, deactivate?: () => void) => async (dispatch: any, getState: () => IRootState) => {
        try {
            let profile = await apiGetProfileInfo(token);
            if (profile?.result) {
                dispatch({ type: ACTION_TYPES.UPDATE_ACCOUNT, payload: profile.result });
            } else {
                dispatch(logOutAuth());
                dispatch(
                    actionUpdateAccessToken({
                        address: '',
                        token: '',
                        nonce: 0,
                        tapRootAddress: '',
                        segWitAddress: '',
                        signature: '',
                    }),
                );
                typeof deactivate === 'function' && deactivate();
            }
        } catch (e) {
            console.log('actionGetProfileInfo error: ', e);
            dispatch(logOutAuth());
            dispatch(
                actionUpdateAccessToken({
                    address: '',
                    token: '',
                    nonce: 0,
                    tapRootAddress: '',
                    segWitAddress: '',
                    signature: '',
                }),
            );
        }
    };

export const actionGetProfileByAddress = (address: string) => async (dispatch: any, getState: () => IRootState) => {
    try {
        let profile = await apiGetProfileByAddress(address);
        return profile?.result || [];
    } catch (e) {
        console.log('actionGetProfileByAddress error: ', e);
    }
};

export const actionUpdateProfile = (data: any, token: string) => async (dispatch: any, getState: () => IRootState) => {
    try {
        let profile = await apiUpdateAccount(data, token);
        if (profile?.result) {
            dispatch(actionGetProfileInfo(token));
        }
        return profile;
    } catch (e) {
        console.log('actionUpdateProfile error: ', e);
    }
};
